import { useMemo } from "react";

import { deleteAction } from "b2b/components/common-grid-columns";
import * as COLUMNS_AVAILABLE from "b2b/components/smlouvy-grid-columns/columnsAvailable";

export default function useColumns({ handleDelete }) {
  const columns = [
    COLUMNS_AVAILABLE.cislo(),
    COLUMNS_AVAILABLE.popis(),
    COLUMNS_AVAILABLE.fixniMZO(),
    COLUMNS_AVAILABLE.fixniVZO(),
    COLUMNS_AVAILABLE.platnostOd(),
    COLUMNS_AVAILABLE.platnostDo(),
    deleteAction(handleDelete, ({ dataRow }) => !dataRow?.pouzito)
  ];
  return useMemo(() => [columns], [handleDelete]);
}
